import React, { useState, useRef, useEffect } from "react";
import { DateRange } from "react-date-range";
import format from "date-fns/format";
import { enUS } from "date-fns/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const DateRangePickerComponent = ({ range, setRange, onApply }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  // Close the calendar if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    // document.addEventListener("mousedown", handleClickOutside);
    // return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (ranges) => {
    setRange([ranges.selection]);
    setOpen(false); // close after selection
  };
  const waitingForSecondClick = useRef(false);

  const handleChange = (item) => {
    // item.selection is the normal shape from react-date-range
    const selection = item.selection ?? item;

    // If user has clicked start only, selection.endDate may be null (or equal to start
    // depending on version). We treat the first meaningful change as "start clicked"
    if (!waitingForSecondClick.current) {
      // If endDate is null OR equals startDate (some versions set it immediately),
      // treat this as start selection and wait for the next click.
      if (!selection.endDate || +selection.startDate === +selection.endDate) {
        setRange([
          { startDate: selection.startDate, endDate: null, key: "selection" },
        ]);
        waitingForSecondClick.current = true;
        return; // DON'T call onApply yet
      }
    }

    // If we reach here, the user has selected end date (second click) — finalize
    setRange([
      {
        startDate: selection.startDate,
        endDate: selection.endDate,
        key: "selection",
      },
    ]);
    waitingForSecondClick.current = false;

    // call consumer with the final selection
    onApply &&
      onApply({ startDate: selection.startDate, endDate: selection.endDate });
  };

  return (
    <div
      className="rel_comp"
      style={{ position: "relative", display: "inline-block" }}
      ref={ref}
    >
      <input
        type="text"
        readOnly
        value={
          range.length > 0
            ? ` ${format(range[0]?.startDate, "dd/MM/yyyy")} ~ ${format(
                range[0]?.endDate,
                "dd/MM/yyyy"
              )}`
            : ""
        }
        onClick={() => setOpen(!open)}
        style={{
          padding: "8px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          width: "250px",
          cursor: "pointer",
          background: "#fff",
        }}
      />
      {open && (
        <div
          style={{
            position: "absolute",
            top: "110%",
            left: "-222px",
            zIndex: 100,
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        >
          <DateRange
            editableDateInputs={true}
            onChange={handleChange}
            moveRangeOnFirstSelection={false} // <-- important (prevents hover select)
            retainEndDateOnFirstSelection={true}
            ranges={range}
            months={2}
            direction="horizontal"
            rangeColors={["#3d91ff"]}
            locale={enUS}
            showDateDisplay={false} // <-- Hide the extra input fields
            showPreview={false}
          />
        </div>
      )}
    </div>
  );
};

export default DateRangePickerComponent;
